export const NOTO_SANS_URL = 'https://fonts.googleapis.com/css2?family=Noto+Sans+JP:wght@200;300;400;500;600;900&display=swap';